import * as React from 'react'

import './index.css'

class Scroll extends React.Component {
  state = {
    activeCls: ''
  }
  scrollContainer = null
  
  handleItemClick = (item) => {
    let { loadPanorama } = this.props
    let { id } = item
    console.log(item) // eslint-disable-line
    loadPanorama(id)
  }

  toggle = () => {
    this.setState(({ activeCls }) => ({
      activeCls: activeCls === 'active' ? '' : 'active'
    }))
    return new Promise(resolve => {
      const _handleTransitonEnd = e => {
        console.log('showWithTransition End')
        resolve()
        this.scrollContainer.removeEventListener('webkitTransitionEnd', _handleTransitonEnd)
      }
      this.scrollContainer.addEventListener('webkitTransitionEnd', _handleTransitonEnd)
    })
  }

  handleHideScrollClk = () => {
    this.toggle().then(() => {
      let { toggleScroll } = this.props
      toggleScroll()
    })
  }

  componentDidMount() {
    this.scrollContainer = this.refs.scroll
    setTimeout(() => this.toggle(), 80)
  }
  
  render() {
    let { activeCls } = this.state
    let { panos } = this.props
    return (
      <div ref="scroll" className={`scroll container ${activeCls}`}>
        <ul className="item-container">
          {
            panos.map((pano) => (
              <li className="item" key={pano.id} onClick={() => this.handleItemClick(pano)}>
                <img src={pano.thumbImage} alt={pano.thumbImage} />
                <span>{pano.title}</span>
              </li>
            ))
          }
        </ul>
        <div className="hide-scroll-icon" onClick={this.handleHideScrollClk}></div>
      </div>
    )
  }
}

export default Scroll



// WEBPACK FOOTER //
// ./src/Components/Scroll/index.js